import { useTranslation } from 'react-i18next';
import heroImage from 'assets/images/assist/guest-messaging.jpg';
import { HOSTFULLY_ASSIST_DETAILS_PATH } from '../../HostfullyAssist.constants';
import { HOSTFULLY_ASSIST_SCHEDULE_DEMO_URL } from '../HostfullyAssistMarketing.constants';
import {
  CopyStack,
  CtaRow,
  HeroSubtitle,
  HeroTitle,
  HeroVisual,
  OutlineCtaLink,
  PrimaryCtaLink,
  SectionInner,
  SplitImage,
  SplitRow,
  WhiteSection,
} from '../HostfullyAssistMarketing.styles';

const HeroSection = () => {
  const { t } = useTranslation();

  return (
    <WhiteSection data-testid="assist-hero">
      <SectionInner>
        <SplitRow>
          <CopyStack>
            <HeroTitle>
              {t('pageHostfullyAssist.marketing.hero.headline')}
            </HeroTitle>
            <HeroSubtitle>
              {t('pageHostfullyAssist.marketing.hero.description')}
            </HeroSubtitle>
            <CtaRow>
              <OutlineCtaLink
                href={HOSTFULLY_ASSIST_SCHEDULE_DEMO_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="assist-hero-cta-demo"
              >
                {t('pageHostfullyAssist.marketing.cta.scheduleDemo')}
              </OutlineCtaLink>
              <PrimaryCtaLink
                to={HOSTFULLY_ASSIST_DETAILS_PATH}
                data-testid="assist-hero-cta-try-free"
              >
                {t('pageHostfullyAssist.marketing.cta.tryForFree')}
              </PrimaryCtaLink>
            </CtaRow>
          </CopyStack>
          <HeroVisual>
            <SplitImage
              src={heroImage}
              alt={t('pageHostfullyAssist.marketing.hero.imageAlt')}
            />
          </HeroVisual>
        </SplitRow>
      </SectionInner>
    </WhiteSection>
  );
};

export default HeroSection;
